/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import { useTranslation } from "react-i18next";

interface Props {
	selectedBatch?: any;
}
const PAMediaCleaningHeader: React.FC<Props> = ({ selectedBatch }) => {
	const { t } = useTranslation();
	return (
		<div className="sticky top-0 z-30 bg-white border-b border-slate-200 shadow-sm shrink-0">
			<div className="px-8 py-4 flex justify-between items-center">
				<div className="flex items-center gap-5">
					<div className="w-12 h-12 bg-orange-50 rounded-2xl flex items-center justify-center shadow-inner">
						<span className="material-symbols-outlined text-[#FF7043] text-3xl">
							cleaning_services
						</span>
					</div>
					<div>
						<h2 className="text-xl font-black text-[#1E293B] tracking-tight">
							{t("postAutoclaveProcess.mediaCleaning.title")}
						</h2>
						<p className="text-[11px] font-bold text-slate-400 uppercase tracking-widest mt-0.5">
							{t("postAutoclaveProcess.mediaCleaning.subtext")}
						</p>
					</div>
				</div>

				{selectedBatch && (
					<div className="flex items-center gap-4">
						<div className="bg-white border border-slate-200 rounded-2xl px-5 py-2.5 flex items-center gap-4 shadow-sm">
							<div className="text-right border-r border-slate-100 pr-4">
								<p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
									{t("postAutoclaveProcess.mediaCleaning.batchId")}
								</p>
								<p className="text-sm font-black text-[#1E293B]">
									{selectedBatch.id}
								</p>
							</div>
							<div className="text-right border-r border-slate-100 pr-4">
								<p className="text-[9px] font-black text-slate-400 uppercase tracking-widest">
									{t("postAutoclaveProcess.mediaCleaning.mediaName")}
								</p>
								<p className="text-sm font-bold text-slate-600">
									{selectedBatch.name.split(" ")[0]}
								</p>
							</div>
							<div className="flex items-center gap-3 pl-2">
								<div className="w-9 h-9 bg-red-50 rounded-full flex items-center justify-center border border-red-100">
									<span className="material-symbols-outlined text-red-500 text-xl">
										{t("postAutoclaveProcess.mediaCleaning.history")}
									</span>
								</div>
								<div className="text-left">
									<p className="text-[9px] font-black text-red-400 uppercase tracking-widest">
										{t("postAutoclaveProcess.mediaCleaning.attempt")}
									</p>
									<p className="text-sm font-black text-red-600">
										{selectedBatch.attempt} / 3
									</p>
								</div>
							</div>
						</div>
						<div className="px-4 py-2 bg-orange-50 border border-orange-100 rounded-xl flex items-center gap-2">
							<div className="w-2 h-2 rounded-full bg-orange-500 animate-pulse"></div>
							<span className="text-[10px] font-black text-orange-600 uppercase tracking-widest">
								{t(
									"postAutoclaveProcess.mediaCleaning.assessmentInProgress",
								)}
							</span>
						</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PAMediaCleaningHeader;
